export default __webpack_public_path__ + "static/media/puesto.2199502e.png";